// styles/base/components/forms.js
/**
 * Form component overrides and variants
 * Because data input deserves the same sophistication as data output
 */

import { alpha, colors } from '../tokens';

export const formOverrides = {
    MuiSelect: {
        variants: [
            {
                props: { variant: 'bootstrap' },
                style: {
                    fontSize: '0.875rem',
                },
            },
        ],
    },

    MuiOutlinedInput: {
        variants: [
            {
                props: { variant: 'bootstrap' },
                style: {
                    borderRadius: '4px',
                    '& .MuiOutlinedInput-input': {
                        padding: '8px 12px',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: alpha(colors.text, 0.23),
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderWidth: '1px',
                        borderColor: colors.primary,
                    },
                },
            },
        ],
    },

    MuiInputLabel: {
        variants: [
            {
                props: { variant: 'bootstrap' },
                style: {
                    fontSize: '0.875rem',
                    transform: 'translate(12px, 12px) scale(1)',
                    '&.Mui-focused': {
                        color: colors.primary,
                    },
                    '&.MuiInputLabel-shrink': {
                        transform: 'translate(12px, -6px) scale(0.75)',
                    },
                },
            },
        ],
    },

    MuiTextField: {
        styleOverrides: {
            root: {
                '& .MuiInputBase-root': {
                    borderRadius: '4px',
                },
            },
        },
    },

    MuiFormControl: {
        styleOverrides: {
            root: {
                marginBottom: '16px', // More economical spacing than the original theme.spacing(3)
                '&:last-child': {
                    marginBottom: 0, // Because the last field shouldn't push unnecessarily
                },
            },
        },
    },
};
